import React, { FC, useEffect, useState } from "react";
import MainLayout from "../../Layouts/MainLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomTable from "../atoms/CustomTable";
import axios from "../../../config/axios";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { service } from "../../../services/AxiosServices";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import { usePhase } from "../../../context/PhaseContext";
import { toast } from "react-toastify";
import ConfirmDialog from "../atoms/ConfirmDialog";
import AccessControl from "../molecules/AccessControl";
import AccessDenied from "../atoms/AccessDenied";
import Spinner from "../atoms/Spinner";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
interface FinetuneResponse {
  task_id: string;
  output: string;
  timing: string;
}
interface ExpectedOutputResponse {
  task_id: string;
  output: string;
}
const Finetune: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const crewName = location.state?.crewName || "crew";
  const response = location.pathname.toLowerCase().startsWith("/response");
  const [finetune, setFinetune] = useState<FinetuneResponse[]>([]);
  const [isSwitchOn, setIsSwitchOn] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const {getPhase,fetchPhase} = usePhase()
  const space = location.pathname.includes('space-finetune_response')
  const crewFineTune = location.pathname.includes('/finetune_response')
  const [showCompleteDialog, setShowCompleteDialog] = useState(false);
  const [showRevertDialog, setShowRevertDialog] = useState(false);
  const accessCheckLoading = useAccessCheckLoading()

  const currentPhase = getPhase(Number(id));
  const phaseCategory =  crewFineTune ?"crew":space ? "knowledge_hub":""
  useEffect(() => {
    if (id) {
      fetchPhase(Number(id),phaseCategory);
    }
  }, [id]);

  
  const columns = response ? ["Output"] : ["Output", "Timing"];
 
    // Format the date and time from ISO string to readable format
  const formatDateTime = (isoString: string): string => {
    const date = new Date(isoString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${day}-${month}-${year}, ${hours}:${minutes}`;
  };
  // Fetch finetune data based on the response
  useEffect(() => {
    if (response) {
      const expectedOutput = async () => {
        try {
          setLoading(true);

          const response = await service<{ tasks: any }>(
            "api/response",
            "post",
            {
              crew_id: id,
            }
          );
  
          const formattedData = response?.data?.tasks.map((ele: any) => ({
            task_id: ele.task_id,
            output: ele.response,
            timing: formatDateTime(ele.create_at), 
          }));
          
   
          formattedData.sort((a:any, b:any) => new Date(b.timing).getTime() - new Date(a.timing).getTime());
          

          setFinetune(formattedData || []);
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
      expectedOutput();
    } else {
      const finetuneResponse = async () => {
        try {
          setLoading(true);

          const response = await service<{ tasks: any }>(
            "api/finetune-response",
            "post",
            {
              crew_id: id,
            }
          );

          const formattedData = response?.data?.tasks.map((ele: any) => ({
            task_id: ele.task_id,
            output: ele.output,
            timing: formatDateTime(ele.create_at),
          }));
          formattedData.sort((a: any, b: any) => b.task_id - a.task_id);
          setFinetune(formattedData || []);
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      };

      finetuneResponse();
    }
  }, [id]);
  const rows = response
    ? finetune.length > 0
      ? finetune
      : []
    : finetune.length > 0
    ? finetune
    : [];

  const taskId = finetune.map((ele) => ele.task_id);
  const actionButtons = [
    {
      alt: response ? "View" : "Finetune",
      className: "btn btn-primary",
      onClick: (rowIndex: number) => {
        const taskId = rows[rowIndex]?.task_id;
        navigate(`/finetune_overview/${taskId}`, {
          state: { response, id, crewName },
        });
      },
    },
  ];

  const handleSwitchChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsSwitchOn(event.target.checked);

    try {
      const status = event.target.checked ? "True" : "False";

      await service("api/update-finetune-status", "post", {
        crew_id: id,
        status,
      });
    } catch (err) {
      console.error("Error during switch toggle API call:", err);
    }
  };

  const handleComplete = async () => {
    setShowCompleteDialog(true);
  };
  

  const confirmComplete = async() => {

    if(currentPhase === 4){
      try{
        const formData = {
          entity_id:id,
          entity_type:phaseCategory,
          phase:currentPhase,
          user_id:localStorage.getItem('user')
        }
        await service<any>(`api/update-phase`,'post',formData)
        fetchPhase(Number(id), phaseCategory);
        toast.success('Finetune phase is completed', { autoClose: 2000 });
  
  
      }
      catch(err){
      console.log(err)
      }
    }
    else{
       toast.warning('Please complete the previous phase!',{autoClose:2000})
    }
 
  };
  const handleRevert = async () => {
    setShowRevertDialog(true);
  };
  const confirmRevert = async() => {
      
    try {
      const formData = {
        entity_id: id,
        entity_type: 'crew',
        phase: 3,
        revert: true,
        user_id: localStorage.getItem('user')
      };
      await service<any>(`api/update-phase`, 'post', formData);
      fetchPhase(Number(id), 'crew');
      toast.success(`Finetune phase is reverted successfully`, { autoClose: 2000 });
    } catch(err) {
      console.log(err);
      toast.error("Failed to revert phase", { autoClose: 2000 });
    }
  };

  return (
    <MainLayout>

<AccessControl
        requiredPermissions={[
          {
            permission: "Crew_finetuning",
            types: ["read"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
      
      <SectionHeader
       complete={handleComplete}
       phase={currentPhase}
       crewFineTune={crewFineTune}
       spaceFineTune={space}
       back ={true}
       revert={handleRevert}
        title={`${response ? "Output" : "Output finetuning"}:  ${space ? 'Knowledge hub':crewName}`}
      />
       <ConfirmDialog
        show={showCompleteDialog}
        onHide={() => setShowCompleteDialog(false)}
        onConfirm={confirmComplete}
        title="Confirm complete"
        body="Are you sure you want to complete this phase?"
        confirmText="Complete"
      />

      {/* Confirm Revert Dialog */}
      <ConfirmDialog
        show={showRevertDialog}
        onHide={() => setShowRevertDialog(false)}
        onConfirm={confirmRevert}
        title="Confirm revert"
        body="Are you sure you to revert this phase?"
        confirmText="Revert"
      />

      <WindowHeightComponent className={""}>
        <div className="p-3">
          {!response && (
            <FormGroup aria-label="position" row>
              <FormControlLabel
                value="start"
                label= {`Do you want to continue fine-tuning the  ${space ? 'space':'crew'}?`}
                control={
                  <Switch checked={isSwitchOn} onChange={handleSwitchChange} />
                }
                labelPlacement="start"
                style={{ margin: 0 }}
              />
            </FormGroup>
          )}
          {finetune.length > 0 ? (
            <CustomTable
              columns={columns}
              rows={rows}
              actionButtons={isSwitchOn ? actionButtons : undefined}
              permission={'Crew_finetuning'}
            />
          ) : (
            <p className="text-center text-danger">
              {response
                ? "No outputs are available"
                : "No tasks are available for this finetune"}
            </p>
          )}
        </div>
      </WindowHeightComponent>
      </AccessControl>
    </MainLayout>
  );
};

export default Finetune;
